import React from "react";

export default function HardcodedStartColumnTDs(props) {
    return (
        <>
            <td className="c-parts-listing__table-item">
                <button
                    className="c-parts-listing__open-modal"
                    onClick={(e) => {
                        e.preventDefault();
                        props.onClick();
                    }}
                >
                    <img
                        src={
                            props.row.imageUrl
                                ? i18n.CdnHostName + props.row.imageUrl + "?preset=c-article-list&width=68"
                                : ""
                        }
                        alt={props.row.name}
                    />
                </button>
            </td>
            <td className="c-parts-listing__table-item">
                <button
                    className="c-parts-listing__open-modal"
                    onClick={(e) => {
                        e.preventDefault();
                        props.onClick();
                    }}
                >
                    {props.row.name}
                </button>
            </td>
        </>
    );
}
